module.exports = __webpack_public_path__ + "static/img/Cafe Noir.a587a68.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Cafe Noir.jpg
// module id = yPb0
// module chunks = 0